<template>
  <div id="unity-container" class="unity-desktop">
    <canvas id="unity-canvas" ref="unityCanvas" style="width: 100%"></canvas>
    <div id="unity-loading-bar">
      <div
        id="unity-logo"
        :style="`background: url('/games/${gameToken}/TemplateData/unity-logo-dark.png') no-repeat center;`"
      ></div>
      <div
        id="unity-progress-bar-empty"
        :style="`background: url('/games/${gameToken}/TemplateData/progress-bar-empty-dark.png') no-repeat center;`"
      >
        <div
          id="unity-progress-bar-full"
          :style="`background: url('/games/${gameToken}/TemplateData/progress-bar-full-dark.png') no-repeat center;`"
        ></div>
      </div>
    </div>
    <div id="unity-footer" :class="hideFooter ? 'd-none' : ''">
      <div
        id="unity-webgl-Logo"
        :style="`background: url('/games/${gameToken}/TemplateData/webgl-logo.png') no-repeat center;`"
      ></div>
      <div
        id="unity-fullscreen-button"
        :style="`background: url('/games/${gameToken}/TemplateData/fullscreen-button.png') no-repeat center;`"
      ></div>
      <div id="unity-build-title">{{ gameToken }}</div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
export default {
  props: ["gameToken", "hideFooter"],
  name: "UnityWebGL",
  data() {
    return {
      containerId:
        "unityContainer" +
        Number(
          Math.random().toString().substr(3, length) + Date.now()
        ).toString(36),
      gameInstance: null,
      loaded: false,
      progress: 0,
      error: null,
    };
  },
  methods: {
    fullscreen() {
      this.gameInstance.SetFullscreen(1);
    },
    message(gameObject, method, param) {
      if (param === null) {
        param = "";
      }
      if (this.gameInstance !== null) {
        this.gameInstance.SendMessage(gameObject, method, param);
      }
    },
    getGameInstance() {
      return this.gameInstance;
    },
    init() {
      document.getElementById("unity-loading-bar").style.display = "block";
      document.getElementById("unity-loading-bar").style.zIndex = 99999999;
      //eslint-disable-next-line no-undef
      createUnityInstance(
        this.$refs.unityCanvas,
        {
          dataUrl: `/games/${this.gameToken}/Build/${this.gameToken}.data.unityweb`,
          frameworkUrl: `/games/${this.gameToken}/Build/${this.gameToken}.framework.js.unityweb`,
          codeUrl: `/games/${this.gameToken}/Build/${this.gameToken}.wasm.unityweb`,
          streamingAssetsUrl: `/games/${this.gameToken}/StreamingAssets`,
          companyName: `Zinad`,
          productName: `${this.gameToken}`,
        },
        (progress) => {
          document.getElementById("unity-progress-bar-full").style.width = `${
            100 * progress
          }%`;
        }
      )
        .then((unityInstance) => {
          window.unityInstance = unityInstance;
          this.gameInstance = unityInstance;
          document.getElementById("unity-loading-bar").style.display = "none";
          document.getElementById("unity-fullscreen-button").onclick = () => {
            unityInstance.SetFullscreen(1);
          };
        })
        .catch((message) => {
          console.error("Init Error: ", message);
        });
    },
  },
  mounted() {
    if (!this.eventBus) {
      this.eventBus = new Vue({
        data: {
          ready: false,
          load: false,
        },
      });
    }
    if (
      typeof createUnityInstance === "undefined" &&
      this.gameToken &&
      !this.eventBus.load
    ) {
      const script = document.createElement("script");
      script.src = `/games/${this.gameToken}/Build/${this.gameToken}.loader.js`;
      script.setAttribute("async", "");
      script.setAttribute("defer", "");

      this.eventBus.load = true;
      script.onload = () => {
        this.init();
      };
      document.body.appendChild(script);
    } else {
      this.init();
    }
  },
};
</script>

<style scoped>
#unity-container {
  position: absolute;
}
#unity-container.unity-desktop {
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
#unity-container.unity-mobile {
  width: 100%;
  height: 100%;
}
#unity-canvas {
  background: #231f20;
}
.unity-mobile #unity-canvas {
  width: 100%;
  height: 100%;
}
#unity-loading-bar {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: none;
}
#unity-logo {
  width: 154px;
  height: 130px;
}
#unity-progress-bar-empty {
  width: 141px;
  height: 18px;
  margin-top: 10px;
}
#unity-progress-bar-full {
  width: 0%;
  height: 18px;
  margin-top: 10px;
}
#unity-footer {
  position: relative;
}
.unity-mobile #unity-footer {
  display: none;
}
#unity-webgl-logo {
  float: left;
  width: 204px;
  height: 38px;
}
#unity-build-title {
  float: right;
  margin-right: 10px;
  line-height: 38px;
  font-family: arial;
  font-size: 18px;
}
#unity-fullscreen-button {
  float: right;
  width: 38px;
  height: 38px;
}
</style>
